import { ColumnDefinition } from '../../../../../../generic/universal-table/types/column.types'
import { GrowerUiRow } from '../types/growerTable.types'

export const growerTableColumns: ColumnDefinition<GrowerUiRow>[] = [
  {
    key: 'GrowerID',
    title: 'מזהה',
    dataType: 'number',
    width: '70px',
    sortable: true,
    editable: false,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'GrowerName',
    title: 'שם גדל',
    dataType: 'string',
    width: '180px',
    sortable: true,
    editable: true,
    visible: true,
    required: true,
    cellRendererType: 'text',
  },
  {
    key: 'ClientID',
    title: 'לקוח',
    dataType: 'number',
    width: '160px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'text',
    // labelResolver is injected in GrowerTableModule.tsx
  },
  {
    key: 'Active',
    title: 'פעיל',
    dataType: 'boolean',
    width: '70px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'checkbox',
    align: 'center',
  },
  {
    key: 'AccounID',
    title: 'מספר חשבון',
    dataType: 'string',
    width: '120px',
    sortable: false,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'GGN',
    title: 'GGN',
    dataType: 'string',
    width: '130px',
    sortable: false,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'GroupID',
    title: 'קבוצה',
    dataType: 'number',
    width: '90px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Farm_Num',
    title: 'מספר חווה',
    dataType: 'number',
    width: '100px',
    sortable: false,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Exporter_Num',
    title: 'מספר יצואן',
    dataType: 'number',
    width: '110px',
    sortable: false,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Kanat_Num',
    title: 'מספר קנת',
    dataType: 'number',
    width: '100px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'Muaza_Num',
    title: 'מספר מועצה',
    dataType: 'string',
    width: '120px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'FieldMan',
    title: 'שדאי',
    dataType: 'number',
    width: '90px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'ActivityType',
    title: 'סוג פעילות',
    dataType: 'number',
    width: '100px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'Payment_Method',
    title: 'שיטת תשלום',
    dataType: 'number',
    width: '110px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'Pay_Discharge',
    title: 'תשלום פריקה',
    dataType: 'boolean',
    width: '100px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'Pay_Levies',
    title: 'תשלום היטלים',
    dataType: 'boolean',
    width: '110px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'Pay_Logistics',
    title: 'תשלום לוגיסטיקה',
    dataType: 'boolean',
    width: '120px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'PickUp',
    title: 'איסוף עצמי',
    dataType: 'boolean',
    width: '90px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
]
